// login
export const SET_LOGIN_SPINNER = "set_login_spinner";
export const SET_VERIFY_JWT_TOKEN_SPINNER = "set_verify_jwt_token_spinner";
export const SET_ACCESS_TOKEN = "set_access_token";

// user
export const SET_SPINNER_FOR_CHAT_LIST = "set_spinner_for_chat_list";
export const GET_FRIEND_INFO = "get_friend_info";
export const POST_USER_INFO = "post_user_info";
export const REMOVE_USER_INFO = "remove_user_info";
export const ERROR_USER_INFO = "error_user_info";
export const GET_ALL_USER_INFO = "get_all_user_info";
export const LOADING_USER_INFO = "loading_user_info";
export const OPEN_FRIEND_LIST_TAB = "OPEN_FRIEND_LIST_TAB";
export const GET_FRIEND_INFO_FROM_SOCKET = "get_friend_info_from_socket";
export const GET_USER_INFO = "get_user_info";
export const GET_RECEIVER_INFO = "get_receiver_info";
export const UPDATE_FRIEND_STATUS = "update_friend_status";
export const UPDATE_CHAT_STATUS = "update_chat_status";
export const SET_FIND_FRIEND_ERROR = "set_find_friend_error";
export const SET_PROFILE_UPDATE_SPINNER = "set_profile_update_spinner";
export const SET_DELETE_ACCOUNT_FOREVER = "set_delete_account_forever";
export const SET_USER_INFO_SPINNER = "set_user_info_spinner";
// message
export const GET_MESSAGES_FROM_DB = "get_message_from_db";
export const GET_OLD_MESSAGES_FROM_DB = "get_old_message_from_db";
export const POST_ONE_ONE_CHAT = "post_one_one_chat";
export const CHAT_ERROR = "chat_error";
export const CHAT_UPLOAD_PERCENTAGE = "chat_upload_percentage";
export const GET_NEW_MESSAGE_FROM_SOCKET = "get_new_message_from_socket";
export const SCREEN_SIZE = "screen_size";
export const IS_TYPE = "is_type";
export const UPDATE_REACT = "update_react";
export const UPDATE_CHAT_REACT = "update_chat_react";
export const DELETE_CHAT_MESSAGE = "delete_chat_message";
export const SET_ROOM_ID = "set_room_id";
export const REFETCH_MESSAGE = "refetch_message";
export const GET_MESSAGE_SPINNER = "get_message_spinner";
export const DELETE_UNSENT_MESSAGE = "delete_unsent_message";

// webcam
export const SET_CAPTURED_IMAGE = "set_captured_image";
export const SET_IMAGE_VIEW = "set_image_view";
export const TOGGLE_CAMERA = "toggle_camera";
export const SET_WEBCAM_MOOD = "set_webcam_mood";
export const OPEN_CAMERA_MOOD_CHANGE_OPTION = "open_camera_mood_change_option";
export const CAPTURING_VIDEO = "capturing_video";
export const SET_RECORDED_CHUNKS = "set_recorded_chunks";
export const SET_VIDEO_BLOB = "set_video_blob";
export const SET_VIDEO_URL = "set_video_url";

// file upload
export const SELECTED_FILES = "selected_files";

// chat page interaction
export const OPEN_OPTIONS_FOR_CHAT = "open_options_for_chat";
export const REACT_TAB_TOGGLE = "react_tab_toggle";

// chat bar page interaction
export const OPEN_GROUP_MAKING_SECTION = "open_group_making_section";
export const SEARCH_PEOPLE_TO_CREATE_GROUP = "search_peOPLE_to_create_group";
export const SELECTED_PEOPLE_TO_CREATE_GROUP =
	"selected_peOPLE_to_create_group";
export const UPDATED_SELECTED_ID_LIST = "updated_selected_id_list";
export const FINAL_STEP_TO_CREATE_GROUP = "final_step_to_create_group";

// private call
export const OPEN_PRIVATE_CALL = "open_private_call";
export const OPEN_GROUP_CALL = "open_group_call";
export const MY_ID = "my_id";
export const USER_ID = "user_id";
export const READ_STREAM = "read_stream";
export const RECEIVING_CALL = "receiving_call";
export const CALLER = "caller";
export const CALLER_SIGNAL = "caller_signal";
export const CALL_ACCEPTED = "call_accepted";
export const CALL_ENDED = "call_ended";
export const GET_MY_NAME = "get_my_name";
export const GET_USER_NAME = "get_user_name";
export const VOICE_OPEN = "voice_open";
export const VIDEO_OPEN = "video_open";
export const VIDEO_CHAT = "video_chat";
export const CALL_REACH_TO_RECEIVER = "call_reach_to_receiver";
export const CALL_TIMER = "call_timer";
export const START_TIMER = "start_timer";
export const SET_INTERVAL = "set_interval";
export const SET_RECEIVER = "set_receiver";
export const SET_USER_STATUS_TO_RECEIVE_OTHER_CALL =
	"set_user_status_to_receive_other_call";
export const SET_RECEIVER_IS_BUSY = "set_receiver_is_busy";
export const SET_RECEIVER_OFFLINE_STATUS = "set_receiver_offline_status";

// group call
export const SET_PEERS_FOR_GROUP_CALL = "set_peers_for_group_call";
export const ACCEPTOR_SET_PEERS_FOR_GROUP_CALL =
	"acceptor_set_peers_for_group_call";
export const SET_CALLER_NAME = "set_caller_name";
export const SET_SHOW_BUTTON = "set_show_button";
export const SET_ACCEPTED_GROUP_CALL = "set_accepted_group_call";

// group making tab
export const GO_TO_GROUP_LIST = "go_to_group_list";
export const SET_GROUP_LIST_FROM_DATABASE = "get_group_list_from_database";
export const GET_GROUP_INFO_FROM_SOCKET = "get_group_info_from_socket";
export const SET_GROUP_NAME = "set_group_name";
export const GROUP_CREATED_SUCCESSFULLY = "set_group_created_successfully";
export const GROUP_CREATING_SPINNER = "set_group_creating_spinner";
export const CLEAR_SELECTED_ID_FOR_GROUP = "clear_selected_id_for_group";
export const CLEAR_GROUP_CREATED_SUCCESSFULLY_STATUS =
	"set_group_created_successfully_status";

// group info
export const GET_GROUP_INFO = "get_group_info";
export const SET_SPINNER_FOR_GROUP_LIST = "set_spinner_for_group_list";
export const SET_ADD_MEMBER_SPINNER = "set_add_member_spinner";
export const SET_ADD_MEMBER_COMPLETE_ICON = "set_add_member_complete_icon";
export const SET_ADD_MEMBER_ERROR_ICON = "set_add_member_error_icon";
